/**
 * StudentQuestsScreen — « Mes quêtes » de l'élève (route `skill-set`), à la place de
 * `student/progress/my progress/MySkillSetsTabScreen.js` quand l'espace élève est allumé.
 *
 * Patron A : `getSkillSets` à l'ouverture et à la flèche (`useStudentQuestsData`), les quêtes mises en
 * forme par `studentQuestsViewModel`. Une carte ouvre le détail (`skill-sets`).
 */
import React from "react"
import { useSelector } from "react-redux"

import { StudentQuestsPage } from "../../../../../../design-system/student"
import { studentQuestsViewModel } from "../../../../view-models/student/Game/studentQuestsViewModel"
import { useStudentQuestsData } from "./useStudentGameData"
import { useStudentQuestsState } from "./useStudentGameState"

export function StudentQuestsScreen() {
    const { refresh } = useStudentQuestsData()
    const vm = useSelector(studentQuestsViewModel)
    const state = useStudentQuestsState()

    return <StudentQuestsPage quests={vm.quests} loading={vm.loading} error={vm.error} onRetry={refresh} {...state} />
}
